<template>
  <SearchBarWrapped v-if="!container" />
  <SearchBarUnwrapped v-if="container" />
</template>

<script>
import { defineComponent } from "vue";
import SearchBarWrapped from "@/components/widgets/searchbar/SearchBarWrapped.vue"; // @ is an alias to /src
import SearchBarUnwrapped from "@/components/widgets/searchbar/SearchBarUnwrapped.vue"; // @ is an alias to /src

// import routes from "@/router/index";

export default defineComponent({
  name: "SearchBar",
  components: { SearchBarWrapped, SearchBarUnwrapped },
  setup() {
    let container = false;
    const myEle = document.getElementById("crentSearchBar");
    if (myEle !== null) {
      if (myEle.dataset.disablecontainer) {
        container = myEle.dataset.disablecontainer === "false" ? false : true;
      }
    }
    return { container };
  },
});
</script>
